var $ = require('jQuery');
var Component = require('./Component');
var dispatcher = require('../global/dispatcher');
var ActionType = require('../constant/ActionType');
var msgitem;
var onpalyended = function () {
    dispatcher.dispatch({
        type: ActionType.MSG_AUDIO_READ_END,
        data: msgitem
    });
};
var AudioPlayer = function (options) {
    (function (self) {
        var defaults = {
            template: '<audio autoplay="autoplay" onended="" onpause=""></audio>'
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
        self._element[0].onended = function () {
            onpalyended();
        };
        self._element[0].onpause = function () {
            onpalyended();
        };
    })(this);
};
AudioPlayer.prototype = Object.create(Component.prototype);
AudioPlayer.prototype.play = function (msg) {
    if (typeof (msg) === 'string') {
        this._element.attr('src', msg);
    } else {
        msgitem = msg;
        this._element.attr('src', msg.content.url);
        dispatcher.dispatch({
            type: ActionType.MSG_AUDIO_READ_START,
            data: msg
        });
    }
};
AudioPlayer.prototype.stop = function () {
    this._element.attr('src', '');
};

module.exports = AudioPlayer;